module.exports = __webpack_public_path__ + "static/img/case_3.a1e516b4.jpg";